import React from 'react';
import { TitleHeader } from 'web-library';
import { useHistory, useLocation } from 'react-router-dom';
import IndividualResultRelease from '../../../modules/result/IndividualResultRelease';
import * as QUERIES from '../../../api/candidate/result/@coordinator/queries-services/queries';
import RouteKey from '../../../routes/key';

const { result } = RouteKey.child;
const { coordinatorIndividualResult } = RouteKey.result.child;

const CoordinatorIndividualResultRelease = () => {
  const { state } = useLocation<{ indexNo: string; listingCode: any }>();
  const history = useHistory();

  if (!state || state.indexNo === undefined) {
    history.push(`/${result}/${coordinatorIndividualResult.route}`);
  }

  const { data } = QUERIES.useGetCoordinatorResultReleaseByIndexNo(state?.indexNo, {
    cacheTime: 0,
    staleTime: 0,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: false,
    enabled: state && state.indexNo !== undefined,
    onError: (errors) => {
      if (errors.response && errors.response?.status === 403) {
        history.push('/error/403');
      } else if (errors.response && errors.response?.status === 400) {
        history.push('/error/404');
      }
    },
  });

  return (
    <>
      <TitleHeader title="Results" />
      {data && (
        <IndividualResultRelease
          candidateResultData={data}
          listingCode={state.listingCode}
          eligibleForResit={false}
        />
      )}
    </>
  );
};
export default CoordinatorIndividualResultRelease;
